module.exports = __webpack_public_path__ + "img/三相混合逆变器.31095a7c.png";